import { repositories } from 'api';
import { StoreBasicDataApiStructure } from 'common/types';

export const getIsUserPromoter = (state: { me: StoreBasicDataApiStructure<repositories.MeType> }) => Boolean(state.me.data?.isPromoter);
